var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4L2 4V6.17071C3.16519 6.58254 4 7.69378 4 9C4 10.3062 3.16519 11.4175 2 11.8293V14H16V11.8293C14.8348 11.4175 14 10.3062 14 9C14 7.69378 14.8348 6.58254 16 6.17071V4ZM17 4C17 3.44772 16.5523 3 16 3H2C1.44772 3 1 3.44772 1 4V7C2.10457 7 3 7.89543 3 9C3 10.1046 2.10457 11 1 11V14C1 14.5523 1.44772 15 2 15H16C16.5523 15 17 14.5523 17 14V11C15.8954 11 15 10.1046 15 9C15 7.89543 15.8954 7 17 7V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 3V4.5C11.5 4.77614 11.7239 5 12 5C12.2761 5 12.5 4.77614 12.5 4.5V3H11.5ZM12 7C12.2761 7 12.5 7.22386 12.5 7.5V10.5C12.5 10.7761 12.2761 11 12 11C11.7239 11 11.5 10.7761 11.5 10.5V7.5C11.5 7.22386 11.7239 7 12 7ZM12 13C12.2761 13 12.5 13.2239 12.5 13.5V15H11.5V13.5C11.5 13.2239 11.7239 13 12 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.df6f17d52356ad35f2df649556db3a83.svg";
export { ForwardRef as ReactComponent };